import { Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Home from './routes/Home';
import HavingIt from './routes/HavingIt';
import HallOfFame from './routes/HallOfFame';
import HowItWorks from './routes/HowItWorks';
import About from './routes/About';
import Submit from './routes/Submit';
import NotFound from './routes/NotFound';

export default function App() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Nav />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/havingit" element={<HavingIt />} />
          <Route path="/hall-of-fame" element={<HallOfFame />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/about" element={<About />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
}
